
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"58","height":"58","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"filter":"url(#filter0_d_1407_9889)"}},[_c('rect',{attrs:{"x":"8","y":"5","width":"42","height":"42","rx":"21","fill":"#fff"}})]),_c('path',{attrs:{"d":"M27 31l4.305-4.464a1 1 0 00-.026-1.414L27 21","stroke":"#000","stroke-width":"2","stroke-linecap":"round"}}),_c('defs',[_c('filter',{attrs:{"id":"filter0_d_1407_9889","x":"0","y":"0","width":"58","height":"58","filterUnits":"userSpaceOnUse","color-interpolation-filters":"sRGB"}},[_c('feFlood',{attrs:{"flood-opacity":"0","result":"BackgroundImageFix"}}),_c('feColorMatrix',{attrs:{"in":"SourceAlpha","values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0","result":"hardAlpha"}}),_c('feOffset',{attrs:{"dy":"3"}}),_c('feGaussianBlur',{attrs:{"stdDeviation":"4"}}),_c('feColorMatrix',{attrs:{"values":"0 0 0 0 0.131944 0 0 0 0 0.17625 0 0 0 0 0.208333 0 0 0 0.15 0"}}),_c('feBlend',{attrs:{"in2":"BackgroundImageFix","result":"effect1_dropShadow_1407_9889"}}),_c('feBlend',{attrs:{"in":"SourceGraphic","in2":"effect1_dropShadow_1407_9889","result":"shape"}})])])])
          )
        }
      }
    